import React  from 'react'
import css from 'styled-jsx/css'
import { motion } from 'framer-motion'
const { className, styles } = css.resolve`
	div {
		height: 35px;
		width: 35px;

		cursor: pointer;
	}
`

const SubmitButton = () => {
	return (
		<svg
			width="61px"
			height="61px"
			viewBox="0 0 61 61"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="Page-1" stroke="none" fill="none" fill-rule="evenodd">
				<g
					id="Being-Copy-16"
					transform="translate(-1192.000000, -474.000000)"
					stroke="#000000"
					stroke-width="2"
				>
					<g id="Group-8" transform="translate(667.000000, 474.000000)">
						<g id="Group-9" transform="translate(525.000000, 0.000000)">
							<g
								id="Group-2"
								transform="translate(19.029921, 9.337493)"
								stroke-linecap="round"
							>
								<g
									id="left-arrow"
									transform="translate(18.470079, 15.162507) rotate(140.000000) translate(-18.470079, -15.162507) translate(10.970079, 1.662507)"
									stroke-linejoin="bevel"
								>
									<path
										d="M15,27 L1.15262601,15.7047214 C0.474835767,15.1601887 0.0571877333,14.3613194 0,13.5 C0.0520543938,12.6372786 0.470707901,11.836486 1.15262601,11.2952786 L15,0"
										id="Path"
									></path>
								</g>
								<line
									x1="17.4700792"
									y1="16.1625071"
									x2="0.47007925"
									y2="33.1625071"
									id="Path-3"
								></line>
							</g>
							<circle id="Oval" cx="30.5" cy="30.5" r="29"></circle>
						</g>
					</g>
				</g>
			</g>
			<style jsx>{`
				svg {
					height: 35px;
					width: 35px;
				}
			`}</style>
		</svg>
	)
}

const EmailCaptureSubmit = ({ onSubmit, submitted }) => {
	return (
		<>
			<motion.div
				whileHover={{ scale: 0.95 }}
				animate={{ scale: submitted ? 0 : 1, width: submitted ? 0 : 35 }}
				className={className}
				onClick={onSubmit}
			>
				<SubmitButton />
			</motion.div>

			{styles}
		</>
	)
}

export default EmailCaptureSubmit
